// The print server's storage quota of a printer: "0.3 / 20 MB" and a small pie chart.

const KB = 1024;
const MB = 1024 * 1024;
export const WARN_AT = 0.5; // yellow from half full
export const FULL_AT = 0.8; // red from four fifths

function size(bytes) {
  if (bytes < 100 * KB) return `${Math.round(bytes / KB)} KB`;
  return `${(Math.round((bytes / MB) * 10) / 10).toString()} MB`;
}

// stored, quota: bytes. Returns { fraction (0..1), level: 'ok' | 'warn' | 'full', text, title } or null without numbers.
export function quotaView(stored, quota) {
  if (!Number.isFinite(stored) || !Number.isFinite(quota) || quota <= 0) return null;
  const fraction = Math.min(1, Math.max(0, stored / quota));
  const level = fraction >= FULL_AT ? 'full' : fraction >= WARN_AT ? 'warn' : 'ok';
  const quotaText = quota >= MB ? `${Math.round((quota / MB) * 10) / 10} MB` : size(quota);
  const usedText = size(stored);
  const percent = Math.round(fraction * 100);
  const help = level === 'full'
    ? ' The printer stops accepting prints when it is full: delete old jobs.'
    : ' Old jobs expire by themselves; you can also delete them.';
  return { fraction, level, text: `${usedText} / ${quotaText}`, title: `${percent}% of this printer's storage on the print server is used.${help}` };
}

// A pie in a 20 x 20 SVG: a ring and a circle whose stroke is as wide as its radius, so that the dash length is the slice.
export const PIE_CIRCUMFERENCE = 2 * Math.PI * 5;
export function pieDash(fraction) {
  const slice = fraction <= 0 ? 0 : Math.max(0.6, fraction * PIE_CIRCUMFERENCE); // a tiny share stays visible
  return `${slice.toFixed(2)} ${PIE_CIRCUMFERENCE.toFixed(2)}`;
}
